import type { LocationDescriptor } from 'history';
import React from 'react';
import { withRouter } from 'react-router';
import type { LinkProps, RouteComponentProps } from 'react-router-dom';
import { LocaleLink } from '../ContentLink/LocaleLink';

type NestedLinkProps = Pick<LinkProps, Exclude<keyof LinkProps, 'to'>> &
  RouteComponentProps & {
    nestedTo: LocationDescriptor;
  };

export function buildNestedPathName(matchUrl: string, nestedPathName?: string): string {
  if (!nestedPathName) return matchUrl;
  if (matchUrl.indexOf(nestedPathName) > -1) return matchUrl;
  if (matchUrl === '/' || matchUrl.indexOf('/m/') > -1) return nestedPathName;
  matchUrl = matchUrl.replace(/\/+$/, '');
  return matchUrl + nestedPathName;
}

export function buildTo(matchUrl: string, nestedTo: LocationDescriptor): LocationDescriptor {
  if (typeof nestedTo === 'string') {
    return buildNestedPathName(matchUrl, nestedTo);
  }

  return {
    ...nestedTo,
    pathname: buildNestedPathName(matchUrl, nestedTo.pathname),
  };
}

const NestedLink: React.FC<NestedLinkProps> = ({
  nestedTo,
  match,
  history,
  location,
  staticContext,
  ...props
}) => <LocaleLink {...props} to={buildTo(match.url, nestedTo)} />;

const Routed = withRouter(NestedLink);

type RoutedProps = Pick<NestedLinkProps, Exclude<keyof NestedLinkProps, keyof RouteComponentProps>>;

export { Routed as NestedLink, RoutedProps as NestedLinkProps };
